import _kebabCase from 'lodash/kebabCase';
import { MEDIA_LABELS, MEDIA_TYPES } from './constants';

/**
 * Returns url for hero image
 * @param  {Array} media array of media objects
 */
export const getHeroImage = (media) => {
  const image = media.find(
    (item) =>
      (item.label || '').toLowerCase() === MEDIA_LABELS.HERO &&
      item.media_type === MEDIA_TYPES.IMAGE
  );
  return image && image.url;
};

/**
 * Returns url for location page with query params added
 * @param  {String} name name of location
 * @param  {String} _entity_id id of location
 * @param  {String} currentQuery the search query and applied filters
 */
export const getLocationUrl = (name, _entity_id, currentQuery) => {
  const locationName = _kebabCase(name);
  return locationName
    ? `/location/${locationName}/${_entity_id}${currentQuery || ''}`
    : null;
};

/**
 * Returns formatted string phone number
 * @param  {Array} contacts array of contact objects
 */
export const getPhone = (contacts) => {
  const phone =
    contacts && contacts.find((item) => item.contact_type === 'phone');
  return phone && phone.value;
};

/**
 * Gets a displayable address string for a location
 * @param {object} location The location to get the display address for.
 * @return {string} Display friendly address string
 */
export function getLocationDisplayAddress(location) {
  const street2 = location.street2 ? location.street2 + ', ' : '';
  const suite = location.suite ? location.suite + ', ' : '';
  return `${location.street1}, ${street2}${suite}${location.city}, ${location.state} ${location.zip}`;
}

/**
 * Returns Google Maps link for directions
 * @param  {Object} address contains address fields
 */
export const getGoogleMapsLink = (name = '', address) => {
  const baseMapUrl = 'https://www.google.com/maps/search/?api=1&query=';
  const addressFields = ['street1', 'street2', 'suite', 'city', 'state', 'zip'];
  const truthyFieldsArr = addressFields
    .map((field) => address[field])
    .filter(Boolean)
    .join(', ');

  const encodedAddress = encodeURIComponent(`${name}, ${truthyFieldsArr}`);

  return `${baseMapUrl}${encodedAddress}`;
};

/**
 * Returns interpunct-separated accessibility features
 * @param  {Array} accessibility contains accessibility objects
 */
export const getAccessibilityInfo = (accessibility) => {
  const filteredNames = accessibility.map((item) => item.name).filter(Boolean);
  const joinedInfo = filteredNames.join(' · ');
  return joinedInfo;
};
